import { render, staticRenderFns } from "./router-container.vue?vue&type=template&id=4eddbf94"
import script from "./router-container.vue?vue&type=script&lang=js"
export * from "./router-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports